package music.jammers.shared.user.domain.model

enum class UserType {
    MUSICIAN,
    ADMIN,
}